module.exports = __webpack_public_path__ + "img/en-top-bg.312e4879.png";